const menu = () => import('./menu');
const group = () => import('./group');
const groupRules = () => import('./groupRules');

// admin
const admin = () => import('./admin');
const adminEdit = () => import('./adminEdit');
const adminExtend = () => import('./adminExtend');
const department = () => import('./department');

const pwoerRouter = [
  {
    path: '/Power/menu', name: 'menu', component: menu, meta: { c: 'power', a: 'menu' }
  },
  {
    path: '/Power/group', name: 'group', component: group, meta: { c: 'power', a: 'group' }
  },
  {
    path: '/Power/groupRules/:id', name: 'groupRules', component: groupRules, meta: { c: 'power', a: 'groupRules' }
  },
  // 用户管理
  {
    path: '/Power/admin', name: 'admin', component: admin, meta: { c: 'power', a: 'admin' }
  },
  {
    path: '/Power/adminEdit/:id?', name: 'adminEdit', component: adminEdit, meta: { c: 'power', a: 'adminEdit' }
  },
  {
    path: '/Power/adminExtend/:id?', name: 'adminExtend', component: adminExtend, meta: { c: 'power', a: 'adminExtend' }
  },
  {
    path: '/Power/department', name: 'department', component: department, meta: { c: 'power', a: 'department' }
  },
];

export default pwoerRouter;
